<script>
import AccordionComponent from "@/components/Components/AccordionComponent/AccordionComponent.vue";

export default {
  name: "FullCareView",
  components: {
    AccordionComponent
  },
  data() {
    return {
      fullCareData: [] // Initialize as an empty array
    };
  },
  async mounted() {
    this.fullCareData = await this.$store.dispatch("fullCare/getFullCare");
  }
};
</script>

<template>
  <div class="full-care-wrapper container-custom">
    <div class="full-care-heading-wrapper">
      <div class="full-care-title">{{ $t("full-care-title") }}</div>
      <div class="full-care-description">{{ $t("full-care-description") }}</div>
    </div>
    <div class="full-care-accordeon-wrapper">
      <div v-for="item in fullCareData" :key="item.id" class="mb-3">
        <AccordionComponent :content="item.content" :title="item.title"/>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.full-care-wrapper {
  padding-top: 90px;

  .full-care-title {
    font-size: $title-h4;
    line-height: 1;
    color: $color-brown;
    text-transform: uppercase;
    font-family: $font-bold;
    margin-bottom: $spacing-3;
  }

  .full-care-description {
    font-size: 14px;
  }

  .full-care-heading-wrapper, .full-care-accordeon-wrapper {
    padding: 20px;
  }

  .full-care-accordeon-wrapper {
    background: $color-grey;
    border-radius: 30px;
    margin-bottom: $spacing-10;
  }
}

@media screen and (min-width: 768px) {
  .full-care-wrapper {
    .full-care-title {
      text-transform: uppercase;
      font-size: $title-h2;
      line-height: $title-h2;
      font-family: $font-bold;
      margin-bottom: $spacing-2;
    }

    .full-care-description {
      font-size: 16px;
    }

    .full-care-heading-wrapper, .full-care-accordeon-wrapper {
      padding: 100px;
    }
  }
}

@media screen and (min-width: 1200px) {
  .full-care-wrapper {
    .full-care-title {
      font-size: $title-h1;
      margin-bottom: $spacing-5;
    }

    .full-care-heading-wrapper, .full-care-accordeon-wrapper {
      padding: 100px 200px;
    }
  }
}

@media screen and (min-width: 1500px) {
  .full-care-wrapper {
    .full-care-heading-wrapper, .full-care-accordeon-wrapper {
      padding: 100px 300px;
    }
  }
}
</style>
